var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline"},[_c('font-awesome-icon',{staticClass:"blank-icon",class:{ 'invisible': _vm.field != null && _vm.field != '' },attrs:{"icon":['fas', 'exclamation-triangle'],"fixed-width":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }